const model = {
    name: 'Templates',
    properties: {
        sections: { type: 'array' },
        devices: { type: 'array' },
        keep_variables: {},
        keep_original_css: {},
    },
};
export default model;
